import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";

import {withAuthentication} from './components';
import Layout from "./modules/layout";
import * as actions from './application.actions';

import './assets/main.css';
import './assets/animate.css';
import './assets/site.css';
import 'ag-grid/dist/styles/ag-grid.css';
import 'ag-grid/dist/styles/theme-fresh.css';
import './assets/global-styles.css';
import 'font-awesome/css/font-awesome.css';
import './assets/toastr.css';
import '@opuscapita/react-dates'

class App extends React.Component {

  componentDidMount() {
    const {actions: {fetchNavigation, fetchFacilities, fetchReviewers, fetchMQDs}} = this.props;
    fetchFacilities();
    fetchReviewers();
    fetchMQDs();
    fetchNavigation();
  }

  render() {
    return (<Layout/>);
  }
}

const ConnectedLayout = connect(
  () => ({}),
  dispatch => ({
    actions: bindActionCreators({...actions}, dispatch)
  })
)(App);



export default withAuthentication(ConnectedLayout);




// WEBPACK FOOTER //
// ./src/App.js